module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/457.92460642.png";